import React from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import ImpactPic from "../images/perempuan.png"
import { Link } from "gatsby"
import { useTranslation } from "react-i18next"

export default function Impact() {
  const { t } = useTranslation()
  return (
    <section id="our-impact-section" className="our-impact-section">
      <div id="impact-section" className="impact-section">
        <Container>
          <Row>
            <Col sm={6}>
              <div className="impact-section-img">
                <img src={ImpactPic} alt="impact" loading="lazy"></img>
              </div>
            </Col>
            <Col sm={6}>
              <div className="impact-section-content">
                <h1 className="title-section">Our Impact</h1>
                <h6 className="sub-title">Education is the reason</h6>
                <p className="text-content mt-3">{t("yati")}</p>
              </div>
              <div className="impact-section-btn">
                <Button as={Link} to="/impact" className="main-btn">
                  {t("readTheStory")}
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  )
}
